import React, {Component} from 'react';
import './ExhibitorRecommendationCTAButton.css';
import RightArrowIcon from './RightArrowIcon';
import PropTypes from 'prop-types';
import {EXHIBITOR_DIRECTORY_RECOMMENDATION, DataDtmActions, ConsentGroups} from '../common/Constants';
import Tags from '../common/dtmTags';
import Utils from '../common/Utils';
import CrossIcon from './CrossIcon';

class ExhibitorRecommendationCTAButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            exhibitorId: '',
            exhibitorName: '',
            isLastVisitedExhibitor: false,
            recommendationUrl: '',
            visitorId: Utils.hasConsent(ConsentGroups.functional)
                ? Utils.getFromLocalStorage(EXHIBITOR_DIRECTORY_RECOMMENDATION.activeVisitor)
                : null,
            isGeneralBannerActive: true,
        };
    }

    componentDidMount() {
        this.handleStorageChange();
        window.addEventListener('storage', this.handleStorageChange);
    }

    componentWillUnmount() {
        window.removeEventListener('storage', this.handleStorageChange);
    }

    handleStorageChange = () => {
        if (!Utils.hasConsent(ConsentGroups.functional)) {
            return;
        }
        let lastVisitedExhibitor = Utils.getFromLocalStorage(EXHIBITOR_DIRECTORY_RECOMMENDATION.lastVisitedExhibitor)
        lastVisitedExhibitor = lastVisitedExhibitor !== null ? JSON.parse(lastVisitedExhibitor) : lastVisitedExhibitor;
        let visitor = Utils.getFromLocalStorage(EXHIBITOR_DIRECTORY_RECOMMENDATION.activeVisitor);
        if (lastVisitedExhibitor) {
            let recommendationUrl = Utils.getRecommendationURL(this.props.interfaceLocale.toLowerCase(),lastVisitedExhibitor.exhibitorId);
            this.setState({
                exhibitorId: lastVisitedExhibitor.exhibitorId,
                exhibitorName: lastVisitedExhibitor.exhibitorName,
                isLastVisitedExhibitor: true,
                recommendationUrl: recommendationUrl,
                visitorId: visitor
            });
        }
    };

    handleExhibitorDirectoryRecommendationButton = () => {
        window.open(this.state.recommendationUrl, '_self');
    }

    handleCloseButton = () => {
        this.setState({
            isGeneralBannerActive: false
        })
    }

    render() {
        return (
            <div className={'exhibitor-recommendation'}
                 style={{
                     '--brand-primary': window.reactSettings.props.themes.brandPrimary,
                     '--button-font-color': window.reactSettings.props.themes.buttonFontColor,
                 }}>
                {this.state.isLastVisitedExhibitor ?
                    <button className={'cta-button'}
                            onClick={this.handleExhibitorDirectoryRecommendationButton}
                            data-dtm={Tags.exhibitorDirectory.exhibitorDirectoryRecommendationButton}
                            data-dtm-actions={DataDtmActions.click}
                            data-dtm-attributes={
                                JSON.stringify({
                                    visitorid: this.state.visitorId,
                                    exhibitorid: this.state.exhibitorId,
                                })
                            }
                    >
                        <span className={'cta-button-text'}
                              data-dtm={Tags.exhibitorDirectory.exhibitorDirectoryRecommendationButtonView}
                              data-dtm-actions={DataDtmActions.view}
                              data-dtm-attributes={
                                  JSON.stringify({
                                      visitorid: this.state.visitorId,
                                      exhibitorid: this.state.exhibitorId,
                                  })
                              }>
                            {this.props.exhibitorDirectoryRecommendationTranslations.discoverMoreLikeButtonText} {this.state.exhibitorName}
                        </span>
                        <span className={'right-arrow-icon'}><RightArrowIcon width={17} height={30} color={'#FFFFFF'} />
                        </span>
                    </button>
                    :
                    this.state.isGeneralBannerActive && <div
                        className={'default-banner'}
                    >
                        <div className={'default-banner-text'}>
                            {this.props.exhibitorDirectoryRecommendationTranslations.noRecommendationsButtonText}
                        </div>
                        <div className={'close-button-wrapper'}>
                            <button className={'close-button'} onClick={this.handleCloseButton}
                                    data-dtm={Tags.exhibitorDirectory.exhibitorDirectoryRecommendationCloseButton}
                                    data-dtm-actions={DataDtmActions.click}
                                    data-dtm-attributes={
                                        JSON.stringify({
                                            visitorid: this.state.visitorId,
                                        })
                                    }><CrossIcon/>
                            </button>
                        </div>
                    </div>
                }
            </div>
        )
    }
}

ExhibitorRecommendationCTAButton.propTypes = {
    baseApiUrl: PropTypes.string.isRequired,
    eventEditionId: PropTypes.string.isRequired,
    interfaceLocale: PropTypes.string.isRequired,
    exhibitorDirectoryRecommendationTranslations: PropTypes.string.isRequired
}

export default ExhibitorRecommendationCTAButton;